import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useWhatsappCallsRuntime } from './WhatsappCallsRuntimeContext';

/**
 * Closes InitiateCall when Voice Platform clears outbound dialing (call_hangup / reset).
 * InitiateCall is local React state; Redux outboundDialingCall drives the "llamando" leg.
 */
export default function useVoiceInitiateCallCloseSync({ isOpen, onClose }) {
  const { provider } = useWhatsappCallsRuntime();
  const outboundDialingCall = useSelector((state) => (
    provider === 'voice' ? state.voiceReducer.outboundDialingCall : null
  ));

  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const trackedDialingIdRef = useRef(null);

  useEffect(() => {
    if (provider !== 'voice') {
      trackedDialingIdRef.current = null;
      return undefined;
    }

    if (!isOpen) {
      trackedDialingIdRef.current = null;
      return undefined;
    }

    const dialingId = outboundDialingCall?.callControlId ?? null;
    if (dialingId) {
      trackedDialingIdRef.current = dialingId;
      return undefined;
    }

    if (trackedDialingIdRef.current) {
      trackedDialingIdRef.current = null;
      onCloseRef.current?.();
    }

    return undefined;
  }, [provider, isOpen, outboundDialingCall]);

  return undefined;
}
